// extracted by mini-css-extract-plugin
export default {"root":"mh9I22"};